import { ChevronDown } from 'lucide-react'
import { INDIAN_STATES, INDIAN_UNION_TERRITORIES } from '../utils/indianStates'

interface StateSelectProps {
  id?: string
  value: string
  onChange: (value: string) => void
  className?: string
}

/**
 * India's states and union territories, grouped. A current value outside that list - free text
 * from before this existed, or a reverse-geocoded spelling that doesn't match - is kept as its own
 * option rather than silently dropped, so switching to this control never blanks out real data.
 */
export function StateSelect({ id, value, onChange, className = 'input' }: StateSelectProps) {
  const known = INDIAN_STATES.includes(value as never) || INDIAN_UNION_TERRITORIES.includes(value as never)
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${className} appearance-none pr-9`}
      >
        <option value="">Select state</option>
        {value && !known && <option value={value}>{value}</option>}
        <optgroup label="State">
          {INDIAN_STATES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </optgroup>
        <optgroup label="Union Territory">
          {INDIAN_UNION_TERRITORIES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </optgroup>
      </select>
      <ChevronDown size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-ink-400" />
    </div>
  )
}
